import { registerNewsletter } from '../api/newsletter.service.js'

export default {
  state:{
  },
 
  mutations: {
  
  },
  actions: {
   
 
    async registerNewsletter(context, user) {
        console.log("newsletter store register \n", user)
      let usr = await registerNewsletter(user)
      context.commit('registerNewsletter', usr)
      return usr
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/newsletter.store.js